import { useCallback } from 'react';
import { getLastPersonDomIndex } from '../utils/discoverFeedItems.utils';

export const useDiscoverFeedNavigation = ({
	feedRef,
	feedItems,
	activeIndex,
}) => {
	const lastPersonDomIndex = getLastPersonDomIndex(feedItems);

	const scrollToDomIndex = useCallback(
		(domIndex) => {
			const feed = feedRef.current;

			if (!feed || domIndex < 0 || domIndex >= feedItems.length) {
				return;
			}

			if (feedItems[domIndex]?.type === 'skeleton') {
				return;
			}

			feed.children[domIndex]?.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		},
		[feedItems, feedRef],
	);

	const goToNext = useCallback(() => {
		const currentItem = feedItems[activeIndex];

		if (currentItem?.type === 'skeleton') {
			return;
		}

		if (activeIndex < lastPersonDomIndex) {
			scrollToDomIndex(activeIndex + 1);
			return;
		}

		scrollToDomIndex(0);
	}, [activeIndex, feedItems, lastPersonDomIndex, scrollToDomIndex]);

	const goToPrevious = useCallback(() => {
		const currentItem = feedItems[activeIndex];

		if (currentItem?.type === 'skeleton') {
			return;
		}

		if (activeIndex > 0) {
			scrollToDomIndex(activeIndex - 1);
			return;
		}

		if (lastPersonDomIndex >= 0) {
			scrollToDomIndex(lastPersonDomIndex);
		}
	}, [activeIndex, feedItems, lastPersonDomIndex, scrollToDomIndex]);

	return {
		goToPrevious,
		goToNext,
	};
};
